import { ConnectionStatus } from '@/libs/signalR/vuexStore/store/state';

const getters = {
  hubToken: (state) => () => state.hubToken,
  hubConnectionEstablished: (state) => () => state.connectionStatus === ConnectionStatus.ClientConnected
}

export default getters
